export default __webpack_public_path__ + "static/media/icon-facebook.df5ad63d.svg";